import { createContext, useContext } from "react";

type PageTourContextValue = {
  advanceFrom: (stepId: string) => void;
};

const PageTourContext = createContext<PageTourContextValue>({ advanceFrom: () => {} });

export default PageTourContext;

export function useTourAdvance() {
  return useContext(PageTourContext).advanceFrom;
}
